import { FIXED_ITEM, type ComponentType } from '../../constants/analytics/component-type.tsx';
import type { MenuLinkItemAnalytics } from './types.tsx';

type Arg = Omit<MenuLinkItemAnalytics, 'componentType'> & {
	componentType?: ComponentType;
};

export const getMenuItemAnalytics = ({
	componentType = FIXED_ITEM,
	itemId,
	...restAttrs
}: Arg): MenuLinkItemAnalytics => ({
	componentType,
	itemId,
	...restAttrs,
});
